import { render, staticRenderFns } from "./CreateUnit.vue?vue&type=template&id=e8e1653a&"
import script from "./CreateUnit.vue?vue&type=script&lang=ts&"
export * from "./CreateUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports